import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const COMPANY = {
  raison: "MONASAR",
  marque: "Monaga Adflow",
  siren: "948 217 365",
  siret: "948 217 365 00018",
  tva: "FR 42 948217365",
  rcs: "RCS Marseille 948 217 365",
  adresse: "127 Chemin de Saint-Joseph, Sainte-Marthe, 13014 Marseille, France",
  directeur: "Direction de la publication — MONASAR",
  email: "jamdiam33@gmail.com",
  hebergeur: "Emergent Cloud — infrastructure sécurisée européenne",
};

const Row = ({ label, value }) => (
  <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-4 py-3 border-b border-border">
    <span className="text-sm text-muted-foreground w-full sm:w-56 shrink-0">{label}</span>
    <span className="text-sm font-medium">{value}</span>
  </div>
);

const Section = ({ title, children }) => (
  <div className="mb-8">
    <h2 className="font-display text-xl font-bold mb-3">{title}</h2>
    <div className="text-sm text-muted-foreground leading-relaxed space-y-3">{children}</div>
  </div>
);

export default function Legal() {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <section className="pt-32 pb-24 px-6">
        <div className="max-w-3xl mx-auto">
          <span className="text-xs font-semibold tracking-widest uppercase text-primary">Informations légales</span>
          <h1 className="font-display text-4xl font-extrabold mt-3 mb-10">Mentions légales</h1>

          <div className="p-6 rounded-2xl border border-border bg-card mb-10">
            <h2 className="font-display text-xl font-bold mb-4">Éditeur du site</h2>
            <Row label="Éditeur (raison sociale)" value={COMPANY.raison} />
            <Row label="Marque" value={COMPANY.marque} />
            <Row label="SIREN" value={COMPANY.siren} />
            <Row label="SIRET" value={COMPANY.siret} />
            <Row label="N° TVA intracommunautaire" value={COMPANY.tva} />
            <Row label="RCS" value={COMPANY.rcs} />
            <Row label="Adresse du siège" value={COMPANY.adresse} />
            <Row label="Directeur de la publication" value={COMPANY.directeur} />
            <Row label="E-mail" value={COMPANY.email} />
            <Row label="Hébergeur" value={COMPANY.hebergeur} />
          </div>

          <Section title="Propriété intellectuelle">
            <p>L'ensemble des contenus présents sur Monaga Adflow (textes, visuels, logo, interface, technologies d'intelligence artificielle) est la propriété exclusive de {COMPANY.raison} ou de ses partenaires. Toute reproduction, représentation ou exploitation, totale ou partielle, sans autorisation écrite préalable est interdite.</p>
          </Section>

          <Section title="Protection des données (RGPD)">
            <p>Conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi Informatique et Libertés, vous disposez d'un droit d'accès, de rectification, de portabilité et de suppression de vos données personnelles. Les catalogues produits et données bancaires sont chiffrés et ne sont jamais revendus.</p>
            <p>Pour exercer vos droits, contactez-nous à l'adresse : {COMPANY.email}.</p>
          </Section>

          <Section title="Paiements">
            <p>Les paiements sont traités de manière sécurisée par Stripe. {COMPANY.raison} ne stocke aucune donnée de carte bancaire. Les transactions sont chiffrées de bout en bout.</p>
          </Section>

          <Section title="Cookies">
            <p>Le site utilise des cookies strictement nécessaires à son fonctionnement (authentification, préférences d'affichage). Aucun cookie publicitaire tiers n'est déposé sans votre consentement.</p>
          </Section>

          <Section title="Responsabilité">
            <p>Les visuels et textes générés par l'IA sont fournis à titre d'aide à la création. L'utilisateur reste responsable de la conformité de ses publicités aux politiques des régies publicitaires et à la réglementation applicable.</p>
          </Section>
        </div>
      </section>
      <Footer />
    </div>
  );
}
